export const BUTTON_PURPLE = '#490C4E'
export const GREY = '#F7F7F7'
